import { api } from "../lib/api";
import type { GetReadyCustomTaskInstance } from "../types/task";

/**
 * M005/S04 — User-created Get Ready tasks.
 *
 * The task type discriminator drives the icon and (eventually) the CTA route
 * on the frontend. The deadline is an ISO-8601 string emitted by the
 * <input type="date"> form; the backend stores it as a UTC timestamp.
 */
export const CUSTOM_TASK_TYPES = [
	"questionnaire",
	"monitor",
	"sign",
	"book",
	"upload_doc",
	"test",
	"notify",
] as const;

export type CustomTaskType = (typeof CUSTOM_TASK_TYPES)[number];

export interface CreateCustomTaskInput {
	title: string;
	description?: string;
	taskType: CustomTaskType;
	deadline?: string | null;
}

export interface UpdateCustomTaskInput {
	title?: string;
	description?: string | null;
	taskType?: CustomTaskType;
	deadline?: string | null;
	status?: "pending" | "in_progress" | "completed";
}

export async function getCustomTasks(): Promise<GetReadyCustomTaskInstance[]> {
	const response = await api.get<GetReadyCustomTaskInstance[]>(
		"/api/get-ready-tasks",
	);
	return response.data;
}

export async function createCustomTask(
	input: CreateCustomTaskInput,
): Promise<GetReadyCustomTaskInstance> {
	const response = await api.post<GetReadyCustomTaskInstance>(
		"/api/get-ready-tasks",
		input,
	);
	return response.data;
}

export async function updateCustomTask(
	id: string,
	input: UpdateCustomTaskInput,
): Promise<GetReadyCustomTaskInstance> {
	const response = await api.patch<GetReadyCustomTaskInstance>(
		`/api/get-ready-tasks/${id}`,
		input,
	);
	return response.data;
}

export async function deleteCustomTask(id: string): Promise<void> {
	await api.delete(`/api/get-ready-tasks/${id}`);
}
